var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "export-config": _vm.exportConfig,
          cellClick: _vm.chooseRow,
          cellDbClick: _vm.updateRow,
        },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "参数管理",
            centered: "",
            footer: null,
            maskClosable: false,
            width: 800,
          },
          model: {
            value: _vm.editModalVisible,
            callback: function ($$v) {
              _vm.editModalVisible = $$v
            },
            expression: "editModalVisible",
          },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }